import React, { useState } from "react";
import "./WeekendGetaway.css";

import delhiagra from "../../assets/delhiagra.png";
import delhiudaipur from "../../assets/delhiudaipur.png";
import delhirishikesh from "../../assets/delhirishikesh.png";
import delhimandu from "../../assets/delhimandu.png";
import delhishimla from "../../assets/delhishimla.png";
import { useNavigate } from "react-router-dom";

const cardsData = [
  {
    img: delhiagra,
    title: "Delhi - Agra",
    days: "3 Days 2 Nights",
    link: "/tour-package-data",
  },
  {
    img: delhimandu,
    title: "Jaipur",
    days: "2 Days 1 Night",
    link: "/tour-package-data",
  },
  {
    img: delhiudaipur,
    title: "Udaipur",
    days: "2 Days 1 Night",
    link: "/tour-package-data",
  },
  {
    img: delhirishikesh,
    title: "Rishikesh",
    days: "2 Days 1 Night",
    link: "/tour-package-data",
  },
  {
    img: delhishimla,
    title: "Manali",
    days: "3 Days 2 Nights",
    link: "/tour-package-data",
  },
];

const WeekendGetaway = () => {
  const [activeIndex, setActiveIndex] = useState(2); // center card

  const next = () => {
    setActiveIndex((prev) => (prev + 1) % cardsData.length);
  };

  const prev = () => {
    setActiveIndex((prev) => (prev === 0 ? cardsData.length - 1 : prev - 1));
  };

  // Position logic
  const getPosition = (index) => {
    const diff = (index - activeIndex + cardsData.length) % cardsData.length;

    if (diff === 0) return "center";
    if (diff === 1) return "right1";
    if (diff === 2) return "right2";
    if (diff === 4) return "left1";
    if (diff === 3) return "left2";
    return "";
  };
const navigate=useNavigate()
  return (
    <div className="weekend-main">
      <h1 className="weekend-heading">WEEKEND GETAWAY</h1>

      <div className="carousel">
        {cardsData.map((card, index) => (
          <div
            key={index}
            className={`card ${getPosition(index)}`}
            onClick={() => {
              setActiveIndex(index);
              navigate(card.link, {
                state: { title: card.title },
              });
            }}
          >
            <img src={card.img} alt="" />

            <div className="card-text">
              <h3>{card.title}</h3>
              <p>{card.days}</p>
            </div>
          </div>
        ))}

        <div className="buttons-weekendgetway">
          <button onClick={prev}>❮</button>
          <button onClick={next}>❯</button>
        </div>
      </div>
    </div>
  );
};

export default WeekendGetaway;
